import { render } from "./modal_corbeillecommandes.vue?vue&type=template&id=40e60133&scoped=true"
import script from "./modal_corbeillecommandes.vue?vue&type=script&lang=js"
export * from "./modal_corbeillecommandes.vue?vue&type=script&lang=js"

import "./modal_corbeillecommandes.vue?vue&type=style&index=0&id=40e60133&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40e60133"]])

export default __exports__